@import '../../../../../../../constants/spacing.module.less';
@import '../../../../../../../app-brand/concepts/shipstation-concept-layer-default.module.less';

@input-width: 320px;

.info-icon {
  display: flex;
  align-items: center;
  padding-left: @space-4;
}

.divider-color {
  border-color: var(--grey-300);
}

.po-number-input {
  width: @input-width;
}

.warehouse-dropdown button {
  height: @space-32;
}

.radio-check-list-item {
  padding: 0;
  margin-top: @space-8;
}

.radio-check-list {
  margin-top: -10px;
}

.margin-top-8 {
  margin-top: @space-8;
}

.caption-text {
  color: var(--gray-637381);
}
